import { observable, action, runInAction } from "mobx";
import { Dialog } from "@weapp/ui";
import { getLabel } from "@weapp/utils";

import * as LoginAPI from '../../../api/pc/login';
import { loginParamsType } from "./type";
import { LoginStore } from '../login/standardLogin/store'
import { ResetPass } from "../common/resetpass";
import { clearOneCookie } from "../../../utils";
import { LOCATION_ORIGN } from "../../../constants";

const { message } = Dialog;

export class EbBindStore extends LoginStore {

  routePush: any = null;
  skinInfo: any = {};//皮肤数据信息
  //初始数据
  @action
  init = (routePush: any) => {
    this.routePush = routePush;
    this.getDomainSkinData();
  }

  //获取自定义皮肤数据
  getDomainSkinData = () => {
    const origin = LOCATION_ORIGN;
    LoginAPI.getCustomDomainSkin(origin, 'pc').then((result: any) => {
      runInAction(() => {
        if (result.data?.tenantKey) {
          this.skinInfo.tenantKey = result.data?.tenantKey;
        }
      });
    }).catch((error) => {

    });
  }
  //登录
  @action
  getLogin = (loginParams: loginParamsType, onLoginError: Function, onLoginCommonError?: Function) => {
    loginParams = { ...loginParams, tenantKey: this.skinInfo?.tenantKey }
    LoginAPI.login(loginParams).then((result: any) => {
      if (result?.data?.errorMsg) {
        const msg = result.data.errorMsg;
        if (result.data?.errorMsg?.code === 10276 || result.data?.errorMsg?.code === 10275) {
          onLoginError && onLoginError();
        } else {
          onLoginCommonError && onLoginCommonError();
          message({
            type: "error",
            content: getLabel(msg.i18nId, msg.msg),
            delay: 2000
          })
        }

      } else {
        if (result.data?.needQysCheck) {
          this.changeQysCheckAuthUrl(result.data?.qysCheckAuthUrl || '');
          this.changeQysDialogShown(true);
          clearOneCookie('ETEAMS_TGC');
          //轮询契约锁状态
          this.QysQrcodePolling({
            tenantKey: result.data?.tenantKey,
            qysCheckAuthId: result.data?.qysCheckAuthId
          })
          return;
        }
        //管理员重置密码强制用户修改
        if (result?.data?.needPwdChange) {
          ResetPass.showDialog({ account: loginParams.account, oldPassword: loginParams.password }).then(() => {
            message({ type: "success", content: getLabel('154716', '修改成功，请重新登录') });
          });
          return;
        }
        if (result.data?.redirectUrl) {
          this.clearCookie(() => {
            window.location.href = `${result.data?.redirectUrl}${result.data.redicretModuleSource ? `&redirectModuleSource=${result.data.redicretModuleSource}` : ``}`;
          })
        }
      }
    });
  }
  //清除后端cookie
  clearCookie = (callback?: Function) => {
    LoginAPI.clearCookie().then(({ status, data }) => {
      if (status) {
        callback && callback();
      }
    })
  }
}

const instance = new EbBindStore();

export default instance;
export type EbBindStoreType = Pick<EbBindStore, keyof EbBindStore>;
